import { KeenSliderOptions } from 'keen-slider/react';

export const SLIDER_OPTIONS = {
  loop: true,
  drag: true,
  mode: 'free' as const,
  dragSpeed: 0.5,
  slides: {
    perView: 'auto',
    spacing: 12,
  },
} satisfies KeenSliderOptions;
